/* eslint-disable @typescript-eslint/prefer-for-of */
type ITFunc<T> = (item: T) => any;

export const listToDictionary = (
	searchKey: any,
	list: any[],
	processItem?: ITFunc<any>,
	processKey?: ITFunc<any>
): { [key: string]: any[] } => {
	const dictionary: { [key: number]: any[] } = {};

	if (!list || list.length === 0) {
		throw new Error('There are no items in the provided list');
	}

	for (let i = 0; i < list.length; i++) {
		let key = list[i][searchKey];
		if (processKey) {
			key = processKey(key);
		}
		const value = list[i];

		// pre process items in list
		if (key in dictionary) {
			dictionary[key].push(value);
		} else {
			dictionary[key] = [value];
		}

		if (processItem) {
			processItem(value);
		}
	}

	return dictionary;
};

export const listToDictionaryObject = (
	searchKey: any,
	list: any[],
	processItem?: ITFunc<any>
): { [key: string]: any } => {
	const dictionary: { [key: number]: any[] } = {};

	for (let i = 0; i < list.length; i++) {
		const key = list[i][searchKey];
		const value = list[i];

		// pre process items in list
		dictionary[key] = value;

		if (processItem) {
			processItem(value);
		}
	}

	return dictionary;
};
